export default "__VITE_ASSET__Bg_cp$Ss__"